import React, { useState } from 'react';
import { useContent } from '../../context/ContentContext';
import { DEFAULT_SITE_CONTENT, SITE_CONTENT_SCHEMA } from './SiteContentEditor';
import { EditButton } from './EditorShell';
import { SchemaEditor } from './SchemaEditor';

export const SiteFieldEditor = ({ title, fieldKeys, testId }) => {
  const { content } = useContent();
  const [editing, setEditing] = useState(false);
  const schema = SITE_CONTENT_SCHEMA.filter((field) => fieldKeys.includes(field.key));

  return (
    <>
      <EditButton onClick={() => setEditing(true)} label={title} testId={testId} />
      {editing && (
        <SchemaEditor
          contentKey="site"
          title={title}
          initial={{ ...DEFAULT_SITE_CONTENT, ...(content.site || {}) }}
          schema={schema}
          single
          onClose={() => setEditing(false)}
        />
      )}
    </>
  );
};